import React from 'react';
import styled from 'styled-components';

const SvgContainer = styled.div`
  polyline,
  line {
    fill: none;
  }

  path,
  line {
    stroke-width: 2px;
    stroke-linecap: square;
    stroke-linejoin: square;
    stroke-miterlimit: 10;

    &.round {
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }
`;

const svg = `<svg style="position: absolute; width: 0; height: 0; overflow: hidden;" version="1.1" 
	xmlns="http://www.w3.org/2000/svg" 
	xmlns:xlink="http://www.w3.org/1999/xlink">
	<defs>
	
	<symbol id="logo" viewBox="0 0 179 12">
		<g>
				<polygon points="26 0 26 3.23459865 28.9482318 3.23459865 28.9482318 12 32.0516262 12 32.0516262 3.23459865 35 3.23459865 35 0"></polygon>
				<polygon points="36 0 36 12 44 12 44 9.15374847 38.9413374 9.15374847 38.9413374 7.40700011 44 7.40700011 44 4.56074859 38.9413374 4.56074859 38.9413374 2.94344926 44 2.94344926 44 0"></polygon>
				<polygon points="52.2561969 0 49.3168585 5.41792314 49.284109 5.41792314 49.284109 0 46 0 46 12 49.284109 12 49.284109 6.79259798 49.3168585 6.79259798 52.2561969 12 56 12 52.2232972 5.98380038 56 0"></polygon>
				<polygon points="64.2839192 0 64.2839192 7.6818759 64.2530001 7.6818759 61.2438232 0 57 0 57 12 59.7159396 12 59.7159396 3.80062382 59.7469999 3.80062382 63.3580404 12 67 12 67 0"></polygon>
				<polygon points="70 12 73 12 73 0 70 0"></polygon>
				<polygon points="82.2840604 0 82.2840604 7.6818759 82.2531413 7.6818759 79.2439644 0 75 0 75 12 77.7160808 12 77.7160808 3.80062382 77.7469999 3.80062382 81.3580404 12 85 12 85 0"></polygon>
				<polygon points="87 0 87 12 95 12 95 9.15374847 89.9413917 9.15374847 89.9413917 7.40700011 95 7.40700011 95 4.56074859 89.9413917 4.56074859 89.9413917 2.94344926 95 2.94344926 95 0"></polygon>
				<polygon points="104.283919 0 104.283919 7.6818759 104.253 7.6818759 101.243823 0 97 0 97 12 99.7162219 12 99.7162219 3.80062382 99.7468587 3.80062382 103.35804 12 107 12 107 0"></polygon>
				<polygon points="120.256103 0 117.317109 5.41792314 117.283909 5.41792314 117.283909 0 114 0 114 12 117.283909 12 117.283909 6.79259798 117.317109 6.79259798 120.256103 12 124 12 120.223204 5.98380038 124 0"></polygon>
				<path d="M172.387327,6.66321473 L173.484302,2.16732007 L173.515698,2.16732007 L174.455983,6.66321473 L172.387327,6.66321473 Z M175.881964,0 L171.180827,0 L168,12 L171.08664,12 L171.713545,9.41223463 L175.160874,9.41223463 L175.81903,12 L179,12 L175.881964,0 Z" ></path>
				<path d="M143.089793,7.40530326 C143.089793,8.65266427 142.354934,9.2211697 141.499863,9.2211697 C140.644791,9.2211697 139.909932,8.6528087 139.909932,7.40530326 L139.909932,0 L137,0 L137,7.64232496 C137,10.3262599 138.485088,12 141.499863,12 C144.514912,12 146,10.3262599 146,7.64232496 L146,0 L143.089793,0 L143.089793,7.40530326 Z"></path>
				<path d="M152.476989,5.70900215 L150.984565,5.70900215 L150.984565,2.94356091 L152.569315,2.94356091 C153.400253,2.94356091 154.10762,3.29935646 154.10762,4.23729566 C154.10762,5.09445965 153.492439,5.70900215 152.476989,5.70900215 M152.907799,0 L148.000141,0 L148,0 L148,12 L150.984565,12 L150.984565,8.36126932 L152.846013,8.36126932 C155.399909,8.36126932 157,6.63081589 157,3.68740291 C157,0.420593239 155.061426,0 152.907799,0"></path>
				<path d="M163.476917,5.70900215 L161.984705,5.70900215 L161.984705,2.94356091 L163.569248,2.94356091 C164.400084,2.94356091 165.107907,3.29935646 165.107907,4.23729566 C165.107907,5.09445965 164.492415,5.70900215 163.476917,5.70900215 M163.907607,0 L159.000141,0 L159,0 L159,12 L161.984424,12 L161.984424,8.36126932 L163.845959,8.36126932 C166.400256,8.36126932 168,6.63081589 168,3.68740291 C168,0.420593239 166.061476,0 163.907607,0"></path>
				<path d="M127.18103,0 L124,12 L127.086847,12 L127.713735,9.41235067 L131.160974,9.41235067 L131.81897,12 L135,12 L131.881759,0 L127.18103,0 Z M129.484016,2.16734679 L129.515697,2.16734679 L130.455671,6.66329688 L128.3875,6.66329688 L129.484016,2.16734679 Z"></path>
				<g>
						<polygon points="14.8183792 7.0163561 17.2304862 11.9956244 22.9739767 0.140209756 18.1494736 0.140209756"></polygon>
						<polygon points="5.74330252 0.140165854 11.4870824 11.9955805 16.3114409 11.9955805 10.568095 0.140165854"></polygon>
						<polygon points="1.44654088e-05 0.140165854 5.74336038 11.9955805 10.5680082 11.9955805 4.82451761 0.140165854"></polygon>
						<polygon points="17.2304572 0.140165854 11.4871113 0.140165854 14.3587843 6.06787317"></polygon>
				</g>
    </g>
	</symbol>
	
	<symbol id="chevron-left" viewBox="0 0 8 12">
			<polygon points="7.7,1.4 6.3,0 0.3,6 6.3,12 7.7,10.6 3.1,6 "/>
	</symbol>
	
	<symbol id="chevron-right" viewBox="0 0 8 12">
		<polygon points="0.3,10.6 1.7,12 7.7,6 1.7,0 0.3,1.4 4.9,6 "/>
	</symbol>
	
	<symbol id="copy" viewBox="0 0 20 23">
		<path id="ic_3" class="st0" d="M19,21H8V7h11V21z M19,5H8C6.9,5,6,5.9,6,7v14c0,1.1,0.9,2,2,2h11c1.1,0,2-0.9,2-2V7 C21,5.9,20.1,5,19,5L19,5z M16,1H4C2.9,1,2,1.9,2,3v14h2V3h12V1z"/>
	</symbol>

	</defs>
</svg>`;

const SVGDefs = () => (
  <SvgContainer dangerouslySetInnerHTML={{ __html: svg }} />
);

export default SVGDefs;



// WEBPACK FOOTER //
// ./src/icons/svgdefs.js